import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

export default function MobileNavbar() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkLoginStatus = () => {
      const loginData = localStorage.getItem("Login_info");
      if (loginData) {
        setIsLoggedIn(true);
      }
    };
    window.addEventListener("storage", checkLoginStatus);
    checkLoginStatus();
    return () => {
      window.removeEventListener("storage", checkLoginStatus);
    };
  }, [isLoggedIn]);

  return (
    <>
      <nav className="navbar navbar-footer navbar-light mob-nav-mia fixed-bottom bottom-nav d-block d-md-none">
        <div className="container-fluid">
          <div className="nav-item active">
            <NavLink className="nav-link" to="/">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.26389 9.5H1.375L9.875 1L18.375 9.5H16.4861"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.26392 9.5V16.1111C3.26392 16.6121 3.46292 17.0925 3.81716 17.4468C4.17139 17.801 4.65184 18 5.1528 18H14.5972C15.0982 18 15.5787 17.801 15.9329 17.4468C16.2871 17.0925 16.4861 16.6121 16.4861 16.1111V9.5"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.04163 18V12.3333C7.04163 11.8324 7.24063 11.3519 7.59487 10.9977C7.9491 10.6435 8.42955 10.4445 8.93051 10.4445H10.8194C11.3204 10.4445 11.8008 10.6435 12.155 10.9977C12.5093 11.3519 12.7083 11.8324 12.7083 12.3333V18"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="font-9 ff-regular text-muted">Home</span>
            </NavLink>
          </div>

          <div className="nav-item ">
            <NavLink className="nav-link" to="/">
              <svg
                width="21"
                height="19"
                viewBox="0 0 21 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.6875 2.0625H20.1875"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.6875 6.3125H17"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.6875 12.6875H20.1875"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.6875 16.9375H17"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.0625 2.0625C1.0625 1.78071 1.17444 1.51046 1.3737 1.3112C1.57296 1.11194 1.84321 1 2.125 1H6.375C6.65679 1 6.92704 1.11194 7.1263 1.3112C7.32556 1.51046 7.4375 1.78071 7.4375 2.0625V6.3125C7.4375 6.59429 7.32556 6.86454 7.1263 7.0638C6.92704 7.26306 6.65679 7.375 6.375 7.375H2.125C1.84321 7.375 1.57296 7.26306 1.3737 7.0638C1.17444 6.86454 1.0625 6.59429 1.0625 6.3125V2.0625Z"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.0625 12.6875C1.0625 12.4057 1.17444 12.1355 1.3737 11.9362C1.57296 11.7369 1.84321 11.625 2.125 11.625H6.375C6.65679 11.625 6.92704 11.7369 7.1263 11.9362C7.32556 12.1355 7.4375 12.4057 7.4375 12.6875V16.9375C7.4375 17.2193 7.32556 17.4895 7.1263 17.6888C6.92704 17.8881 6.65679 18 6.375 18H2.125C1.84321 18 1.57296 17.8881 1.3737 17.6888C1.17444 17.4895 1.0625 17.2193 1.0625 16.9375V12.6875Z"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="font-9 ff-regular text-muted">Orders</span>
            </NavLink>
          </div>
          <div className="nav-item ">
            <NavLink className="nav-link" to="/">
              <svg
                width="19"
                height="19"
                viewBox="0 0 160 167"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M118.26 5H41.74C27.9628 5 21.0742 5 15.9502 7.9763C12.6446 9.89634 9.89634 12.6446 7.9763 15.9502C5 21.0742 5 27.9628 5 41.74V124.867C5 138.777 5 145.732 8.01583 150.882C9.96087 154.204 12.7432 156.956 16.0851 158.866C21.2666 161.827 28.2215 161.753 42.1311 161.605L118.651 160.79C132.295 160.645 139.118 160.572 144.184 157.581C147.454 155.651 150.168 152.908 152.063 149.618C155 144.52 155 137.697 155 124.052V41.74C155 27.9628 155 21.0742 152.024 15.9502C150.104 12.6446 147.355 9.89634 144.05 7.9763C138.926 5 132.037 5 118.26 5Z"
                  stroke="#676767"
                  strokeWidth="10"
                />
                <path
                  d="M155 65V65C155 52.2975 144.703 42 132 42H28C15.2975 42 5 52.2975 5 65V65"
                  stroke="#676767"
                  strokeWidth="10"
                />
                <path
                  d="M7 86H46.2074C52.0706 86 57.6054 88.707 61.2051 93.3351L65.9766 99.47C73.2698 108.847 87.2829 109.307 95.1751 100.428L102.331 92.3771C105.937 88.3208 111.105 86 116.532 86H155"
                  stroke="#676767"
                  strokeWidth="9"
                />
              </svg>

              <span className="font-9 ff-regular text-muted">Documents </span>
            </NavLink>
          </div>

          <div className="nav-item ">
            <NavLink className="nav-link" to="/">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.76392 4.77778C2.76392 5.77971 3.16193 6.7406 3.8704 7.44907C4.57887 8.15754 5.53976 8.55555 6.54169 8.55555C7.54362 8.55555 8.50451 8.15754 9.21299 7.44907C9.92146 6.7406 10.3195 5.77971 10.3195 4.77778C10.3195 3.77585 9.92146 2.81496 9.21299 2.10649C8.50451 1.39801 7.54362 1 6.54169 1C5.53976 1 4.57887 1.39801 3.8704 2.10649C3.16193 2.81496 2.76392 3.77585 2.76392 4.77778Z"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M0.875 18V16.1111C0.875 15.1092 1.27301 14.1483 1.98149 13.4398C2.68996 12.7313 3.65085 12.3333 4.65278 12.3333H8.43055C9.43248 12.3333 10.3934 12.7313 11.1018 13.4398C11.8103 14.1483 12.2083 15.1092 12.2083 16.1111V18"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.1527 1.1228C13.9653 1.33086 14.6856 1.80346 15.1999 2.4661C15.7143 3.12873 15.9935 3.9437 15.9935 4.78253C15.9935 5.62135 15.7143 6.43632 15.1999 7.09895C14.6856 7.76159 13.9653 8.23419 13.1527 8.44225"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.875 18V16.1111C17.8702 15.2773 17.5897 14.4685 17.0772 13.8108C16.5647 13.1531 15.849 12.6834 15.0416 12.475"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="font-9 ff-regular text-muted">Applicant </span>
            </NavLink>
          </div>

          <div className="nav-item ">
            <NavLink className="nav-link" to="/">
              <svg
                width="16"
                height="19"
                viewBox="0 0 16 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.20386 4.57895C3.20386 5.52814 3.58092 6.43846 4.25211 7.10965C4.92329 7.78083 5.83361 8.1579 6.78281 8.1579C7.732 8.1579 8.64232 7.78083 9.31351 7.10965C9.98469 6.43846 10.3618 5.52814 10.3618 4.57895C10.3618 3.62975 9.98469 2.71943 9.31351 2.04825C8.64232 1.37707 7.732 1 6.78281 1C5.83361 1 4.92329 1.37707 4.25211 2.04825C3.58092 2.71943 3.20386 3.62975 3.20386 4.57895Z"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.41443 17.1052V15.3158C1.41443 14.3666 1.7915 13.4562 2.46268 12.7851C3.13386 12.1139 4.04418 11.7368 4.99338 11.7368H8.57233C8.81122 11.7368 9.04564 11.7601 9.27112 11.8048"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.0461 12.6316L11.2566 15.3158H14.8355L13.0461 18"
                  stroke="#676767"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="font-9 ff-regular text-muted">Account </span>
            </NavLink>
          </div>
        </div>
      </nav>
    </>
  );
}
